import React from "react";
import { CircularProgress, RaisedButton } from "material-ui";
import images from "../../config/images";
import { checkMobile, isIpadOS } from "../../lib";

export const Help = (props) => {
  return (
    <span>
      {checkMobile() || isIpadOS() ? <span></span> : <img
        data-tip={`<div class='rc-tooltip'>${props.content}</div>`}
        style={{
          width: "16px",
          height: "16px",
          cursor: "pointer",
          margin: "13px 10px 0 0",
          position: props.isAbsolute ? "absolute" : "unset",
          zIndex: props.isAbsolute ? "999" : "unset"
        }}
        src={images.quetionMark}
      />}
    </span>
  );
};

class Button extends React.Component {
  render() {
    return (
      <RaisedButton
        onTouchTap={this.props.handleButtonClick}
        backgroundColor="#60d1bd"
        labelStyle={{ color: "#fff" }}
        label={this.props.showLoader ? "" : this.props.label}
        labelPosition="before"
        style={{
          height: 42,
          margin: this.props.noSpacing ? "0 10px 0" : "4px 16px 4px 0",
          boxShadow: "none",
          borderRadius: "5px",
          minWidth: this.props.minWidth ? this.props.minWidth : '180px',
          flexGrow: '100',
          maxWidth: this.props.maxWidth ? this.props.maxWidth : "unset"
        }}
        className={this.props.className}
        buttonStyle={{ borderRadius: "5px",minWidth: '180px' }}
        icon={this.props.help && !this.props.showLoader ? <Help content={this.props.helpContent || "..."} /> : null}
      >
        {this.props.showLoader ? (
          <CircularProgress
            style={{ marginTop: "5px" }}
            color="#fff"
            size={30}
          />
        ) : (
          ""
        )}
      </RaisedButton>
    );
  }
}

export default Button;



// WEBPACK FOOTER //
// src/components/EmailAddressBook/Button.js